import React,{useEffect} from "react";
import Navbar from '../../components/Navbar';
import Header from "./Header";
import Section1 from "./Section1";
import "./support.css";
import Section2 from "./Section2";
import Footer from "../footer/Footer";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section3 from "./Section3";


const Support = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
        <Navbar/>
        <Header/>
        <Section1/>
        <Section2/>
        <Section3/>
        <Section4/>
        <Section5/>
        <Footer/>
    </>
  );
};

export default Support;
